var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFriendsEmptyLeaderboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F3F3F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2981_49386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 24C34.6667 22.2319 33.9643 20.5362 32.7141 19.2859C31.4638 18.0357 29.7682 17.3333 28 17.3333C26.2319 17.3333 24.5362 18.0357 23.286 19.2859C22.0358 20.5362 21.3334 22.2319 21.3334 24C21.3334 24.3536 21.4739 24.6927 21.7239 24.9428C21.9739 25.1928 22.3131 25.3333 22.6667 25.3333C23.0203 25.3333 23.3595 25.1928 23.6095 24.9428C23.8596 24.6927 24 24.3536 24 24C24 23.2089 24.2346 22.4355 24.6742 21.7777C25.1137 21.1199 25.7384 20.6072 26.4693 20.3045C27.2002 20.0017 28.0045 19.9225 28.7804 20.0768C29.5563 20.2312 30.2691 20.6121 30.8285 21.1716C31.3879 21.731 31.7688 22.4437 31.9232 23.2196C32.0775 23.9955 31.9983 24.7998 31.6956 25.5307C31.3928 26.2616 30.8801 26.8863 30.2223 27.3259C29.5645 27.7654 28.7912 28 28 28C27.6464 28 27.3073 28.1405 27.0572 28.3905C26.8072 28.6406 26.6667 28.9797 26.6667 29.3333V32C26.6667 32.3536 26.8072 32.6927 27.0572 32.9428C27.3073 33.1928 27.6464 33.3333 28 33.3333C28.3537 33.3333 28.6928 33.1928 28.9428 32.9428C29.1929 32.6927 29.3334 32.3536 29.3334 32V30.5333C30.8392 30.2259 32.1926 29.4077 33.1644 28.2172C34.1363 27.0266 34.667 25.5368 34.6667 24Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 38.6667C28.7363 38.6667 29.3333 38.0697 29.3333 37.3333C29.3333 36.597 28.7363 36 28 36C27.2636 36 26.6666 36.597 26.6666 37.3333C26.6666 38.0697 27.2636 38.6667 28 38.6667Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2981_49386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFriendsEmptyLeaderboard);
export default __webpack_public_path__ + "static/media/profileFriendsEmptyLeaderboard.5d7449dca14e309287f2377b924571a2.svg";
export { ForwardRef as ReactComponent };